module.exports = __webpack_public_path__ + "static/img/chat-pass-off.9cc71ef7.png";